import classNames from 'classnames';
import { useRef } from 'react';

type Props = {
  onSubmit: (data: any) => void;
  children: React.ReactNode;
  className?: string;
  names?: string[];
  disabled?: boolean;
  onChange?: (data: any) => void;
};

function Form({ onSubmit, children, className, disabled, onChange }: Props) {
  const ref = useRef<HTMLFormElement>(null);
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    event.stopPropagation();

    const data: any = {};

    // @ts-ignore
    for (const element of event.target.elements) {
      const name = element.name;
      if (name) data[name] = element.value;
    }

    onSubmit(data);
  };

  const handleChange = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!ref.current) return;

    const data: any = {};

    // @ts-ignore
    for (const element of ref.current.elements) {
      const name = element.name;
      if (name) data[name] = element.value;
    }

    onChange?.(data);
  };

  return (
    <form
      ref={ref}
      onSubmit={handleSubmit}
      onChange={handleChange}
      className={classNames(className, {
        'pointer-events-none': disabled,
        'opacity-50': disabled,
      })}
    >
      {children}
    </form>
  );
}

export default Form;
